import React, { useState } from 'react';

const ContextMenu = ({ x, y, onClose }) => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [showArrangeSubmenu, setShowArrangeSubmenu] = useState(false);
  const [showNewSubmenu, setShowNewSubmenu] = useState(false);

  const handleItemClick = (item) => {
    console.log(`Context menu item clicked: ${item}`);
    onClose();
  };

  const handleArrangeHover = () => {
    setShowArrangeSubmenu(true);
    setShowNewSubmenu(false);
  };

  const handleNewHover = () => {
    setShowNewSubmenu(true);
    setShowArrangeSubmenu(false);
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
    // Don't close submenus immediately to allow navigation
  };

  const arrangeItems = [
    { label: 'by Name', action: 'arrange-name' },
    { label: 'by Size', action: 'arrange-size' },
    { label: 'by Type', action: 'arrange-type' },
    { label: 'by Modified', action: 'arrange-modified' },
    { separator: true },
    { label: 'Show in Groups', action: 'show-groups' },
    { label: 'Auto Arrange', action: 'auto-arrange' },
    { label: 'Align to Grid', action: 'align-grid' }
  ];

  const newItems = [
    { label: 'Folder', action: 'new-folder' },
    { separator: true },
    { label: 'Shortcut', action: 'new-shortcut' },
    { separator: true },
    { label: 'Bitmap Image', action: 'new-bitmap' },
    { label: 'Text Document', action: 'new-text' },
    { label: 'Rich Text Document', action: 'new-rtf' }
  ];

  return (
    <>
      <div 
        className="fixed inset-0 z-40"
        onClick={onClose}
      />
      <div 
        className="fixed z-50 bg-white border border-gray-400 shadow-lg"
        style={{
          left: `${x}px`,
          top: `${y}px`,
          minWidth: '180px',
          fontFamily: 'Tahoma, sans-serif',
          fontSize: '11px'
        }}
        onMouseLeave={handleMouseLeave}
      >
        {/* Arrange Icons By */}
        <div
          className={`flex items-center justify-between px-3 py-1 cursor-pointer ${
            hoveredItem === 'arrange' ? 'bg-blue-500 text-white' : 'text-black'
          }`}
          onMouseEnter={() => {
            setHoveredItem('arrange');
            handleArrangeHover();
          }}
          onClick={() => handleItemClick('arrange')}
        >
          <span>Arrange Icons By</span>
          <span className="ml-2">▶</span>
        </div>

        {/* Refresh */}
        <div
          className={`px-3 py-1 cursor-pointer ${
            hoveredItem === 'refresh' ? 'bg-blue-500 text-white' : 'text-black'
          }`}
          onMouseEnter={() => {
            setHoveredItem('refresh');
            setShowArrangeSubmenu(false);
            setShowNewSubmenu(false);
          }}
          onClick={() => handleItemClick('refresh')}
        >
          Refresh
        </div>

        {/* Separator */}
        <div className="border-t border-gray-300 my-1"></div>

        {/* Paste */}
        <div
          className={`px-3 py-1 cursor-pointer text-gray-400 ${
            hoveredItem === 'paste' ? 'bg-gray-100' : ''
          }`}
          onMouseEnter={() => {
            setHoveredItem('paste');
            setShowArrangeSubmenu(false);
            setShowNewSubmenu(false);
          }}
        >
          Paste
        </div>

        {/* Paste Shortcut */}
        <div
          className={`px-3 py-1 cursor-pointer text-gray-400 ${
            hoveredItem === 'paste-shortcut' ? 'bg-gray-100' : ''
          }`}
          onMouseEnter={() => {
            setHoveredItem('paste-shortcut');
            setShowArrangeSubmenu(false);
            setShowNewSubmenu(false);
          }}
        >
          Paste Shortcut
        </div>

        {/* Separator */}
        <div className="border-t border-gray-300 my-1"></div>

        {/* New */}
        <div
          className={`flex items-center justify-between px-3 py-1 cursor-pointer ${
            hoveredItem === 'new' ? 'bg-blue-500 text-white' : 'text-black'
          }`}
          onMouseEnter={() => {
            setHoveredItem('new');
            handleNewHover();
          }}
          onClick={() => handleItemClick('new')}
        >
          <span>New</span>
          <span className="ml-2">▶</span>
        </div>

        {/* Separator */}
        <div className="border-t border-gray-300 my-1"></div>

        {/* Properties */}
        <div
          className={`px-3 py-1 cursor-pointer ${
            hoveredItem === 'properties' ? 'bg-blue-500 text-white' : 'text-black'
          }`}
          onMouseEnter={() => {
            setHoveredItem('properties');
            setShowArrangeSubmenu(false);
            setShowNewSubmenu(false);
          }}
          onClick={() => handleItemClick('properties')}
        >
          Properties
        </div>
      </div>

      {/* Arrange Icons By Submenu */}
      {showArrangeSubmenu && (
        <div 
          className="fixed z-50 bg-white border border-gray-400 shadow-lg"
          style={{
            left: `${x + 180}px`,
            top: `${y}px`,
            minWidth: '160px',
            fontFamily: 'Tahoma, sans-serif',
            fontSize: '11px'
          }}
        >
          {arrangeItems.map((item, index) => (
            item.separator ? (
              <div key={index} className="border-t border-gray-300 my-1"></div>
            ) : (
              <div
                key={index}
                className="px-3 py-1 cursor-pointer hover:bg-blue-500 hover:text-white"
                onClick={() => handleItemClick(item.action)}
              >
                {item.label}
              </div>
            )
          ))}
        </div>
      )}

      {/* New Submenu */}
      {showNewSubmenu && (
        <div 
          className="fixed z-50 bg-white border border-gray-400 shadow-lg"
          style={{
            left: `${x + 180}px`,
            top: `${y + 140}px`, // Position below "New" item
            minWidth: '160px',
            fontFamily: 'Tahoma, sans-serif',
            fontSize: '11px'
          }}
        >
          {newItems.map((item, index) => (
            item.separator ? (
              <div key={index} className="border-t border-gray-300 my-1"></div>
            ) : (
              <div
                key={index}
                className="px-3 py-1 cursor-pointer hover:bg-blue-500 hover:text-white"
                onClick={() => handleItemClick(item.action)}
              >
                {item.label}
              </div>
            )
          ))}
        </div>
      )}
    </>
  );
};

export default ContextMenu;
